/* Lucira Jewellery — theme scripts */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-header-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dots button');
    if (slides.length < 2) return;
    var index = 0;
    var timer;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }
    function next() { show(index + 1); }
    function start() { timer = setInterval(next, 5000); }
    function stop() { clearInterval(timer); }

    hero.querySelector('.hero__arrow--next').addEventListener('click', function () { stop(); next(); start(); });
    hero.querySelector('.hero__arrow--prev').addEventListener('click', function () { stop(); show(index - 1); start(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { stop(); show(n); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Product variant pills ---------- */
  document.querySelectorAll('[data-variant-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var group = pill.closest('[data-variant-group]');
      if (group) group.querySelectorAll('[data-variant-pill]').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var input = document.querySelector('[data-variant-id]');
      if (input && pill.dataset.variantValue) input.value = pill.dataset.variantValue;
    });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var counter = document.querySelector('[data-cart-count]');
          if (counter) counter.textContent = cart.item_count;
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1500);
        })
        .catch(function () { if (btn) { btn.textContent = original; btn.disabled = false; } });
    });
  });
})();
